export const NO_PDF_COLOR = 'rgba(215, 25, 28, 0.8)';
export const WITH_PDF_COLOR = 'rgba(76, 175, 80,0.8)';
export const FORM_A_IS_LATE_COLOR = 'rgba(255,216,53,0.8)';
